import savedMedications from '../../api/pre_filled_medications'

// STATE
const state = {
  drugs: []
}

// GETTERS
const getters = {
  getSavedDrugs () {
    return state.drugs
  }
}

// ACTIONS
const actions = {
  init ({ commit, state, dispatch }) {
    savedMedications.getSavedMedications().then(response => {
      if (response.status === 200) {
        commit('setUpMedications', response.body.doctor_saved_medications)
      }
    })
  },
  addToSavedDrugs ({ commit, state, dispatch }, { drug }) {
    delete Object.assign(drug, { is_active: drug.isActive }).isActive
    savedMedications.addToSavedMedications({ doctor_saved_medication: drug }).then(response => {
      if (response.status === 200) {
        commit('addToSavedDrugs', response.body.doctor_saved_medication)
      }
    })
  },
  removeSavedDrug ({ commit }, { drugId }) {
    savedMedications.removedSavedMedication(drugId).then(response => {
      if (response.status === 200) {
        commit('removeSavedDrug', drugId)
      }
    })
  },
  editSavedDrug ({ commit, state }, { drugId, medication, isCurrent }) {
    let med = !medication ? isCurrent : medication
    delete Object.assign(med, { is_active: med.isActive }).isActive
    savedMedications.editSavedMedication({ doctor_saved_medication_id: drugId, med: {doctor_saved_medication: med} }).then(response => {
      if (response.status === 200) {
        commit('editSavedDrug', response.body.doctor_saved_medication)
      }
    })
  },
  reset (state) {
    state = {}
  }
}

// MUTATIONS
const mutations = {
  setUpMedications (state, savedDrugs) {
    state.drugs = savedDrugs
  },
  addToSavedDrugs (state, drug) {
    delete Object.assign(drug, { isActive: drug.is_active }).is_active
    state.drugs.push(drug)
  },
  removeSavedDrug (state, id) {
    state.drugs = state.drugs.filter((drug) => drug.id !== id)
  },
  editSavedDrug (state, drug) {
    delete Object.assign(drug, { isActive: drug.is_active }).is_active
    let index = state.drugs.findIndex((med) => med.id === drug.id)
    state.drugs.splice(index, 1, drug)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/pre_filled_medications.js